/* global axios */
import ApiClient from '../ApiClient';

class WhatsappCatalog extends ApiClient {
  constructor() {
    super('whatsapp/catalog_products', { accountScoped: true });
  }

  getProducts(inboxId) {
    return axios.get(this.url, { params: { inbox_id: inboxId } });
  }

  createProduct({ inboxId, product }) {
    return axios.post(this.url, { inbox_id: inboxId, product });
  }

  updateProduct({ inboxId, id, product }) {
    return axios.patch(`${this.url}/${id}`, { inbox_id: inboxId, product });
  }

  deleteProduct({ inboxId, id }) {
    return axios.delete(`${this.url}/${id}`, { params: { inbox_id: inboxId } });
  }

  listCatalogs(inboxId) {
    return axios.get(`${this.baseUrl()}/whatsapp/catalogs`, {
      params: { inbox_id: inboxId },
    });
  }

  setCatalogId({ inboxId, catalogId }) {
    return axios.patch(`${this.baseUrl()}/whatsapp/catalogs/${catalogId}`, {
      inbox_id: inboxId,
    });
  }
}

export default new WhatsappCatalog();
